module.exports = __webpack_public_path__ + "img/application4.93e64423.png";